import { AppHelper } from "../appHelper"
import { Grid } from "../core/components/grid";
import { AppBaseProps, CommonApp } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService } from "../core/util/httpManager";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { Region } from "../core/components/region";
import { Button } from "../core/components/button";
import { IsPanelbarDetails } from "../core/components/isPanelbarDetails";
import { ComponentHelper } from "../core/util/componentHelper";
import { IsSearchField } from "../core/components/isSearchField";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react"
export class AttendanceClockApp extends React.Component<AppBaseProps, AttendanceClockAppState> {
    private attendanceClockGridData: Array<any> = [];
    common = new AppHelper();
    setTabTitle = true;
    translations: StringKeyDictionary<string>;
    attendanceClockGridOptions: kendo.ui.GridOptions;
    resetSelectionRights: boolean;
    clockTimer: Array<any> = [];
    timerID: any;


    constructor(props) {
        super(props);
        this.resetSelectionRights = false;
        this.state = {
            selectedId: null,
            currentTimer: null,
            isTimerWork: null,
            isTimerPause: null,
            offsetTimer: null,
            belegNr: null,
            ressNr: null,
            startWeek: null,
            endWeek: null,
            isError: null
        }
        this.common.enableHooks = true;
        this.common.init(this);
        this.load();

    }

    componentDidMount() {
        this.timerID = setInterval(
            () => this.tick(),
            1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    tick() {
        this.updateTimerState(true);
    }


    private updateArray(arrray: Array<any>) {
        if (Helper.hasValue(arrray)) {
            arrray.forEach(item => {

                var v = parseInt(item["Zvon"]);
                var b = parseInt(item["Zbis"]);

                var t = parseInt(item["Zeittyp"]);

                var za = parseInt(item["Zarbeit"]);
                var zp = parseInt(item["Zpause"]);

                var date = item["Datum"];
                item["Zvon"] = Helper.dates.getMinToHHMM(item["Zvon"]);
                item["Zbis"] = Helper.dates.getMinToHHMM(item["Zbis"]);
                item["Datum"] = Helper.dates.toString(date);
                item["Tag"] = kendo.toString(kendo.parseDate(date), "ddd");

                if (v == b - 1 && (t == 2 && za == 1 && zp == 0) || (t == 2 && zp == 1 && za == 0))
                    item["Diff"] = "-:-"
                else
                    item["Diff"] = Helper.dates.getMinToHHMM(b - v);

                //if (item["Zusatzid"] == "208")
                //    item["Zusatzid"] = "Arbeit"
                //else
                //    item["Zusatzid"] = "Pause";
            })
        }
    }

    private updateTimerState(updateOnTimer: boolean, isError: boolean = null) {
        let timerOffset = 0;
        let isTimerWork = false;
        let isTimerPause = false;
        const isErrorConst = isError;

        if (Helper.hasValue(this.clockTimer) && this.clockTimer.length == 1) {
            let d = new Date;
            let min = d.getHours() * 60 + d.getMinutes();

            const belegnr = this.clockTimer[0]["belegNr"];
            const ressNr = this.clockTimer[0]["ressNr"];
            const startWeek = this.clockTimer[0]["startWeek"];
            const endWeek = this.clockTimer[0]["endWeek"];

            if (updateOnTimer) {
                this.setState({
                    currentTimer: min,
                    belegNr: belegnr,
                    ressNr: ressNr,
                    startWeek: startWeek,
                    endWeek: endWeek
                });
            } else {

                if (this.clockTimer[0]["Zusatzid"] == "208")
                    isTimerWork = true;

                if (this.clockTimer[0]["Zusatzid"] == "209")
                    isTimerPause = true;

                timerOffset = this.clockTimer[0]["Zvon"];
                this.setState({
                    currentTimer: min,
                    offsetTimer: timerOffset,
                    isTimerWork: isTimerWork,
                    isTimerPause: isTimerPause,
                    belegNr: belegnr,
                    ressNr: ressNr,
                    startWeek: startWeek,
                    endWeek: endWeek,
                    isError: isErrorConst
                });
            }

        }
    }


    public openWeeklyReport = () => {
        if (!Helper.hasValue(this.state.belegNr) || this.state.belegNr == 0) {
            NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.WeeklyReport.NichtGefunden"));
            return;
        }

        const url = "WeeklyReport/Edit?id=" + encodeURIComponent(this.state.belegNr);

        const sheet = General.Sheet.Manager.createSheetWithUrl(url);
        sheet.bind(SheetEventType.Close, (target) => {
            this.load();
        });

    }

    private load = () => {

        this.clockTimer = [];

        HTTPService.chainBatch
            .add("AttendanceClock/GetCurrentWeekGridData")
            .add("AttendanceClock/GetCurrentAttendanceClock")
            .promise()
            .then(result => {
                Helper.setArrayValues(this.attendanceClockGridData, result[0]);
                this.updateArray(this.attendanceClockGridData);


                if (result[1].Code === 0) {
                    this.clockTimer.push(result[1].Data);

                    this.updateTimerState(false, false);
                }
                else {
                    NotificationHelper.showErrorMessage(result[1].Message);

                    if (Helper.hasValue(result[1]) && Helper.hasValue(result[1].Data)) {
                        this.clockTimer.push(result[1].Data);
                        this.updateTimerState(false, true);
                    }
                    else
                        this.setState({ isError: true });
                }
            });
    }


    private attendanceClockSelectionChanged = (dataItem) => {
        if (!this.resetSelectionRights) {
            const id = Helper.hasValue(dataItem) ? dataItem.id : null;
            // this.setState({ selectedActionRightsId: id });
            this.setState({});
        }
        else
            this.resetSelectionRights = false;
    }


    private handleBtnClick = (act: AttendanceClockActionType) => {
        HTTPService.post("AttendanceClock/SetCurrentAttendanceClock", { act: act })
            .then((result) => {
                if (result.Code == 0) {
                    this.load();
                }
                else {
                    NotificationHelper.showErrorMessage(result.Message);
                }

            });
    }

    private labelStyle: React.CSSProperties = {
        marginBottom: "2px",
        fontWeight: "bold",
        fontSize: "30px",
        display: "block"
    };

    private btnStyle: React.CSSProperties = {
        marginLeft: "5px",
        marginRight: "2px",
        borderRadius: "50%",
        borderWidth: "2px",
        fontSize: "25px",
        width: "60px",
        height: "60px"
    };

    public hasRessNr = (): boolean => {
        return Helper.hasValue(this.state.ressNr) && this.state.ressNr != 0;
    }

    createGrids = () => {

        let currentTime = "-:- " + this.translations["WebSMS.AttendanceClock.NoTime"];

        let disableBtns = (this.state.currentTimer - this.state.offsetTimer < 4);

        let minTerm = "";

        if (disableBtns)
            minTerm = "\r\n" + this.translations["WebSMS.AttendanceClock.MinimumTerm"];

        let timeLabel = <label className="" style={this.labelStyle}>{currentTime}</label>

        if (!this.state.isError && (this.state.isTimerWork || this.state.isTimerPause)) {

            let str = '';

            if (this.state.isTimerPause)
                str = this.translations["WebSMS.AttendanceClock.PauseTime"] + " " + Helper.dates.getSecToHHMM(this.state.offsetTimer * 60);

            if (this.state.isTimerWork)
                str = this.translations["WebSMS.AttendanceClock.WorkTime"] + " " + Helper.dates.getSecToHHMM(this.state.offsetTimer * 60);


            timeLabel = <label className="" style={this.labelStyle}>{str}</label>
        }


        let button_w = null;
        let button_p = null;
        let button_s = null;

        if (!this.state.isError && this.clockTimer.length > 0 && this.hasRessNr()) {
            button_w = <Button handleClick={() => this.handleBtnClick(AttendanceClockActionType.StartWork)} readOnly={this.state.isTimerWork || disableBtns} buttonStyle={this.btnStyle}
                title={this.translations["WebSMS.AttendanceClock.BtnStartWorkHint"] + minTerm} iconName={"tools"} />
            button_p = <Button handleClick={() => this.handleBtnClick(AttendanceClockActionType.StartPause)} readOnly={this.state.isTimerPause || disableBtns} buttonStyle={this.btnStyle}
                title={this.translations["WebSMS.AttendanceClock.BtnStartPauseHint"] + minTerm} iconName={"coffee"} />
            button_s = <Button handleClick={() => this.handleBtnClick(AttendanceClockActionType.EndActive)}
                readOnly={(!this.state.isTimerWork && !this.state.isTimerPause) || disableBtns} buttonStyle={this.btnStyle}
                title={this.translations["WebSMS.AttendanceClock.BtnStopHint"] + minTerm} iconName={"stop"} />
        }

        let issfProps = ComponentHelper.createFactory().getDefaultSearchFieldProps();
        issfProps.value = this.state.ressNr;
        issfProps.disabled = true;
        issfProps.field.readOnlyTextField = true;
        issfProps.field.searchWindowTitle = this.translations["Ressource.Ressourcensuche"];
        issfProps.field.searchWindowUrl = "DynamicSearch/Window/Resource";


        let ispdProps = ComponentHelper.createFactory().getDefaultPanelbarDetailsProps();
        ispdProps.field.url = "ResourceLookup/ResourceHeader";
        ispdProps.field.template = "ResourceDetails";
        ispdProps.handleEval = this.common.evalAction;
        ispdProps.value = this.state.ressNr;

        return (

            <div className="flex-container">

                <Region title={this.translations["WebSMS.AttendanceClock.AttendanceControl"]} flexContainer={true} >
                    <div className="flex-container flex-container--row flex-container--align-center" style={{ height: "auto", marginTop: 10, marginBottom: 10 }}>
                        <label style={{ marginRight: 20 }}>{this.translations["WebSMS.AttendanceClock.RessName"]}</label><div style={{ width: 200 }}><IsSearchField {...issfProps} /></div>
                    </div>
                    <div style={{ width: 360 }}>
                        <IsPanelbarDetails {...ispdProps} />
                    </div>
                    <div style={{ marginTop: "20px" }}>
                        {timeLabel}
                    </div>
                    <div style={{ marginTop: "20px", marginLeft: "15px" }}>
                        {button_w}
                        {button_p}
                        {button_s}
                    </div>
                </Region>

                <br />

                <Region title={this.translations["WebSMS.AttendanceClock.TimeReportWeeek"]} flexContainer={true} >
                    <Grid data={this.attendanceClockGridData} options={this.attendanceClockGridOptions} id="attendanceClockGrid"
                    />
                </Region>

            </div>
        );
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps());
        return <CommonApp {...props} />;
    }
};




enum AttendanceClockActionType {
    CheckActive = 0,
    EndActive = 1,
    StartWork = 2,
    StartPause = 3
}

interface AttendanceClockAppState {
    selectedId: number,
    currentTimer: number,
    isTimerWork: boolean,
    isTimerPause: boolean,
    offsetTimer: number,
    belegNr: number,
    ressNr: number,
    startWeek: Date,
    endWeek: Date,
    isError: boolean
}
